import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getPlayer } from "@/lib/api";

const PlayerContext = createContext(null);
const STORAGE_KEY = "neondrive.player";

export function PlayerProvider({ children }) {
  const [player, setPlayer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) { setLoading(false); return; }
    try {
      const parsed = JSON.parse(stored);
      // Refresh with latest server data
      getPlayer(parsed.id).then(fresh => {
        setPlayer(fresh);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(fresh));
      }).catch(() => setPlayer(parsed))
        .finally(() => setLoading(false));
    } catch {
      setLoading(false);
    }
  }, []);

  const login = useCallback((p) => {
    setPlayer(p);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(p));
  }, []);

  const logout = useCallback(() => {
    setPlayer(null);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  const updatePlayer = useCallback((patch) => {
    setPlayer(prev => {
      if (!prev) return prev;
      const merged = { ...prev, ...patch };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
      return merged;
    });
  }, []);

  return (
    <PlayerContext.Provider value={{ player, loading, login, logout, updatePlayer }}>
      {children}
    </PlayerContext.Provider>
  );
}

export const usePlayer = () => useContext(PlayerContext);
